import React from 'react';
import proptypes from 'prop-types';
import { Text } from './Text';

const { string, bool } = proptypes;

export const Image = ({
  src,
  alt,
  size,
  subHeader = '',
  subSubHeader = '',
  sideBySide = false,
  stacked = false,
  ranges = false
}) => {

  let containerClass = 'sui-flex sui-flex-col sui-items-center';
  let textMaxWidth = '';
  if (ranges) {
    textMaxWidth = 'sui-max-w-[45%]';
  } else if (sideBySide) {
    textMaxWidth = 'sui-max-w-[55%]';
  } else if (stacked) {
    textMaxWidth = 'sui-max-w-[30%]';
  }

  if (sideBySide || stacked || ranges) {
    return (
      <div className={containerClass}>
        <img
          className="sui-object-contain"
          src={src}
          alt={alt}
          title={alt}
          height={size}
          width={size}
        />
        {subHeader && (
          <div className={`sui-w-full ${textMaxWidth} sui-text-left sui-mt-3`}>
            <Text text={subHeader} />
            {subSubHeader && <Text text={subSubHeader} />}
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <img
        className="sui-object-contain sui-self-start"
        src={src}
        alt={alt}
        title={alt}
        height={size}
        width={size}
      />

      {subHeader && (
        <div className="sui-m-2 !sui-mr-0">
          <Text text={subHeader} />
          {subSubHeader && <Text text={subSubHeader} />}
        </div>
      )}
    </>
  );
};

Image.propTypes = {
  src: string.isRequired,
  alt: string.isRequired,
  size: string.isRequired,
  subHeader: string,
  subSubHeader: string,
  sideBySide: bool,
  stacked: bool,
  ranges: bool
};


